// ---------------------------------------------------------------------------
// ที่เก็บไฟล์ (Storage quota) — logic ล้วน เทสต์ได้
// ---------------------------------------------------------------------------
// พื้นที่ที่ใช้ = ผลรวมขนาดไฟล์ที่ระบบบันทึกไว้ (documents / slips / ไฟล์แนบ custom_requests)
//   - แถวใหม่เก็บ sizeBytes (ตัวเลขไบต์)
//   - แถวเก่าของ documents เก็บ size เป็นข้อความ เช่น "120 KB" -> แปลงกลับเป็นไบต์ให้
//   - แถวที่ไม่มีขนาดเลย (slips เก่า) นับเป็น 0 — ยังไม่มีข้อมูลให้คำนวณ
// limit เป็น GB (null = ไม่จำกัด) 1 GB = 1024^3 ไบต์
// ---------------------------------------------------------------------------

export const GB = 1024 * 1024 * 1024;

const UNIT = { B: 1, KB: 1024, MB: 1024 * 1024, GB };

/** ขนาดเป็นไบต์ของแถวที่มีไฟล์ */
export const sizeBytesOf = (row) => {
  if (!row) return 0;
  const exact = Number(row.sizeBytes);
  if (Number.isFinite(exact) && exact > 0) return Math.floor(exact);
  const match = /^\s*([\d.]+)\s*(B|KB|MB|GB)\s*$/i.exec(String(row.size || ""));
  if (!match) return 0;
  const value = Number(match[1]);
  return Number.isFinite(value) ? Math.round(value * UNIT[match[2].toUpperCase()]) : 0;
};

export const storageUsedBytes = (...lists) =>
  lists.reduce((total, rows) => total + (Array.isArray(rows) ? rows : []).reduce((sum, row) => sum + sizeBytesOf(row), 0), 0);

/**
 * ตรวจก่อนอัปโหลด — อัปโหลดได้ถ้า (ที่ใช้อยู่ + ไฟล์ใหม่) ไม่เกินโควตา
 * limitGb: null = ไม่จำกัด · 0 = ไม่มีสิทธิ์ (ยังไม่มีแพ็กเกจ)
 */
export const storageCheck = (limitGb, usedBytes, addBytes = 0) => {
  if (limitGb === null || limitGb === undefined) return { ok: true, unlimited: true, limitBytes: null, usedBytes, afterBytes: usedBytes + addBytes };
  const limitBytes = Math.max(0, Number(limitGb) || 0) * GB;
  const afterBytes = usedBytes + addBytes;
  return { ok: afterBytes <= limitBytes, unlimited: false, limitBytes, usedBytes, afterBytes };
};

export const formatBytes = (bytes) => {
  const value = Number(bytes) || 0;
  if (value >= GB) return `${(value / GB).toFixed(2)} GB`;
  if (value >= UNIT.MB) return `${(value / UNIT.MB).toFixed(1)} MB`;
  if (value >= UNIT.KB) return `${Math.round(value / UNIT.KB)} KB`;
  return `${value} B`;
};
